import { useState } from "react";
import { Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Throbber from "@/components/throbber";
import { useApplyReferralCode } from "@/hooks/use-mutations";
import { useKycLogout } from "@/components/kyc/use-kyc-logout";
import { handlePaste } from "@/lib/utils";

const ReferralCode = ({ closeModal }: { closeModal: () => void }) => {
  const [code, setCode] = useState("");
  // The account changes with the code, so sign in again to pick it up.
  const logout = useKycLogout("Referral code applied, please log in again");
  const { mutate: applyCode, isPending } = useApplyReferralCode({
    onSuccess: () => {
      closeModal();
      logout();
    },
  });

  const submit = () => {
    const refBy = code.trim();
    if (refBy) applyCode(refBy);
  };

  return (
    <form
      className="mx-auto flex flex-col items-center text-center"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <div className="text-dark-primary-main flex size-16 items-center justify-center rounded-full bg-white">
        <Users className="size-7" />
      </div>
      <p className="mt-4 text-2xl font-medium">Referral Code</p>
      <p className="text-sm">Enter referral code below</p>

      <div className="relative mt-6 w-full">
        <Input
          className="h-14 rounded-xl border border-[#CECECE2E] bg-white/10 pr-16 text-white"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoFocus
        />
        <button
          type="button"
          onClick={() => handlePaste((v) => setCode(v.trim()))}
          className="text-dark-primary-main absolute top-1/2 right-4 -translate-y-1/2 text-sm"
        >
          Paste
        </button>
      </div>

      <Button
        type="submit"
        disabled={!code.trim() || isPending}
        className="bg-dark-primary-main hover:bg-dark-primary-main/80 text-dark-text-400 mt-4 h-12 w-full rounded-xl font-semibold disabled:opacity-40"
      >
        {isPending ? <Throbber /> : "Continue"}
      </Button>
    </form>
  );
};

export default ReferralCode;
